import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { Color } from 'core';
import styled from 'styled-components';
import Tooltip from '@material-ui/core/Tooltip';

interface IProps {
  title: string;
  description: string;
  icon: IconDefinition;
  iconColor: string;
  iconBackgroundColor: string;
  onClick: () => void;
  isSelected?: boolean;
  disabled?: boolean;
  tooltipText?: string;
}

export const SelectionCard = (props: IProps) => {
  const { title, description, icon, iconColor, iconBackgroundColor, onClick, isSelected = false, disabled = false, tooltipText } = props;

  const handleClick = () => {
    if (!disabled) {
      onClick();
    }
  };

  const cardContent = (
    <Card onClick={handleClick} isSelected={isSelected} disabled={disabled}>
      <IconContainer backgroundColor={iconBackgroundColor}>
        <FontAwesomeIcon icon={icon} color={iconColor} size="2x" />
      </IconContainer>
      <CardTitle>{title}</CardTitle>
      <CardDescription>{description}</CardDescription>
    </Card>
  );

  if (disabled && tooltipText) {
    return (
      <Tooltip title={tooltipText} arrow placement="top">
        {cardContent}
      </Tooltip>
    );
  }

  return cardContent;
};

const Card = styled.div<{ isSelected: boolean; disabled: boolean }>`
  border: 2px solid ${props => props.isSelected ? Color.primaryBlue : '#e5e5e5'};
  border-radius: 12px;
  padding: 40px 30px;
  width: 280px;
  text-align: center;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.2s ease;
  background: white;
  opacity: ${props => props.disabled ? 0.5 : 1};

  &:hover {
    ${props => !props.disabled && `
      border-color: ${Color.primaryBlue};
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    `}
  }
`;

const IconContainer = styled.div<{ backgroundColor: string }>`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: ${props => props.backgroundColor};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 30px;
`;

const CardTitle = styled.h4`
  font-size: 24px;
  font-weight: 600;
  color: ${Color.primaryBlack};
  margin-bottom: 15px;
`;

const CardDescription = styled.p`
  font-size: 16px;
  color: ${Color.darkGray};
  line-height: 1.5;
  margin: 0;
`;